import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import PlusImg from '../../../images/plus.png';

const AddTemplateButton = React.memo(() => (
  <Button to="/templateGenerator">
    <Img src={PlusImg} alt="plus" />
  </Button>
));

export default AddTemplateButton;

const Button = styled(Link)`
  position: fixed;
  width: 80px;
  height: 80px;
  right: 25px;
  bottom: 25px;
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  text-align: center;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  background: #5da834;
  color: #fff;
  border-radius: 50%;
  border: 2px solid #000542;
  &:hover {
    background: #1b8100;
  }
  @media (max-width: 768px) {
    width: 60px;
    height: 60px;
  }
  @media (max-width: 500px) {
    right: 15px;
  }
`;

const Img = styled.img`
  width: 70%;
  height: 70%;
`;



// WEBPACK FOOTER //
// ./src/Components/Templates/TemplatesList/AddTemplateButton.jsx